export default {
      id: "logging-usage",
      viewBox: "0 0 548.291 548.291",
      url: __webpack_public_path__ + "img/icons.dd84271a.svg#logging",
      toString: function () {
        return this.url;
      }
    }